import React, { useState } from "react";
import {
  Box,
  TextField,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
  Grid,
  Typography,
} from "@mui/material";
import { DR } from "./dynamicRequest.classes";
import { SCUIContent } from "../../atomic/organisms";
import { SCUIButton, SCUILoadingLinear } from "../../atomic/atoms";
import { DynamicRequestQuery } from "../../services/query";

function DynamicRequest() {
  const [requestUrl, setRequestUrl] = useState("");
  const [requestType, setRequestType] = useState("POST");
  const [requestBody, setRequestBody] = useState("");
  const [requestBodyRows, setRequestBodyRows] = useState(3);
  const [requestParamType, setRequestParamType] = useState("formBody");
  const [response, setResponse] = useState<any>();
  const [loading, setLoading] = React.useState(false);

  const handleRequestTypeChange = (event: any) => {
    setRequestType(event.target.value);
  };

  const handleRequestSubmit = () => {
    setLoading(true);
    const requestData = {
      requestUrl,
      requestType,
      requestBody,
      requestParamType,
    };
    let req: any = { jobj: JSON.stringify(requestData) };
    DynamicRequestQuery.GetDynamicRequest(req)
      .then((res) => {
        setResponse(res);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleRequestBodyChange = (event: any) => {
    setRequestBody(event.target.value);
    const lineCount = event.target.value.split("\n").length;
    setRequestBodyRows(lineCount);
  };

  const handleRequestParamTypeChange = (event: any) => {
    setRequestParamType(event.target.value);
  };
  interface ColoredDataProps {
    data: string;
    color: string;
  }

  const ColoredData: React.FC<ColoredDataProps> = ({ data, color }) => (
    <span style={{ color }}>{data}</span>
  );

  return (
    <SCUIContent>
      <Box className={DR.page}>
        <SCUILoadingLinear display={loading} />
        <Box className={DR.fieldRequestUrl}>
          <TextField
            className={DR.inputTextfieldRequestUrl}
            label="Request URL"
            variant="outlined"
            fullWidth
            value={requestUrl}
            onChange={(e) => setRequestUrl(e.target.value)}
          />
        </Box>
        <Grid
          className={DR.fieldRequestType}
          sx={{ marginTop: "1rem" }}
          size={{
            sm: 12,
            md: 12,
            lg: 12,
            xl: 12
          }}>
          <FormControl component="fieldset" style={{ marginTop: "16px" }}>
            <FormLabel component="legend">Request Type</FormLabel>
            <RadioGroup
              className={DR.inputRadioGroupRequestType}
              row
              value={requestType}
              onChange={handleRequestTypeChange}
            >
              <FormControlLabel value="GET" control={<Radio />} label="GET" />
              <FormControlLabel value="POST" control={<Radio />} label="POST" />
            </RadioGroup>
          </FormControl>
        </Grid>
        <Grid
          className={DR.fieldRequestParamType}
          sx={{ marginTop: "1rem" }}
          size={{
            sm: 12,
            md: 12,
            lg: 12,
            xl: 12
          }}>
          <FormControl component="fieldset" style={{ marginTop: "16px" }}>
            <FormLabel component="legend">Request Param Type</FormLabel>
            <RadioGroup
              className={DR.inputRadioGroupRequestParamType}
              row
              value={requestParamType}
              onChange={handleRequestParamTypeChange}
            >
              <FormControlLabel
                value="formBody"
                control={<Radio />}
                label="FormBody"
              />
              <FormControlLabel
                value="queryString"
                control={<Radio />}
                label="Query String"
              />
            </RadioGroup>
          </FormControl>
        </Grid>
        <Box className={DR.fieldRequestBody}>
          <TextField
            className={DR.inputTextfieldRequestBody}
            label="Request "
            multiline
            rows={requestBodyRows}
            variant="outlined"
            fullWidth
            value={requestBody}
            onChange={handleRequestBodyChange}
            style={{ marginTop: "16px" }}
          />
        </Box>
        <Grid
          className={DR.actionsRow}
          sx={{ marginTop: "1rem" }}
          size={{
            sm: 12,
            md: 12,
            lg: 12,
            xl: 12
          }}>
          <SCUIButton
            className={DR.inputButtonSendRequest}
            onClick={handleRequestSubmit}
            type={"primary"}
            sizeType={"fixed"}
            size={"l"}
            text={"Send Request"}
          ></SCUIButton>
        </Grid>
        {response && (
          <div className={DR.responseSection} style={{ marginTop: "16px" }}>
            <Typography className={DR.responseTitle} variant="h6">Response:</Typography>
            <pre className={DR.responsePre}>
              {JSON.stringify(response, null, 2)
                .split("\n")
                .map((line, index) => (
                  <span key={index}>
                    <ColoredData
                      data={line.substring(0, line.indexOf(":"))}
                      color="blue"
                    />
                    <ColoredData
                      data={line.substring(line.indexOf(":"))}
                      color="red"
                    />
                    <br />
                  </span>
                ))}
            </pre>
          </div>
        )}
      </Box>
    </SCUIContent>
  );
}

export default DynamicRequest;
